import { Plugins, Network } from "@capacitor/core";
import { AppUpdatePlugin } from "capacitor-app-update";

import { StorageService } from "../storage/storage.service";
import { StaticInjectorService } from "./static-injector";
import { NetworkService } from '../network/network.service';
import { MessageService } from '../message/message.service';
import { MobileService } from './mobile-event.service';

/**
 * @desc Get core module instance wiith root injector.
 */

export class CoreToolbox {
	/**
	 * Get storage service.
	 */
	static get storageService(): StorageService {
		return StaticInjectorService.injector.get(StorageService);
	}

	/**
	 * Get message service instance
	 */
	static get messageService(): MessageService {
		return StaticInjectorService.injector.get(MessageService);
	}

	/**
	 * Get network service instance
	 */
	static get networkService(): NetworkService {
		return StaticInjectorService.injector.get(NetworkService);
	}

	/**
	 * Get app update service
	 */
	static get appUpdateService(): AppUpdatePlugin {
		return Plugins.AppUpdatePlugin as AppUpdatePlugin;
	}

	/**
	 * Get mobile service instance
	 */
	static get mobileService(): MobileService {
		return StaticInjectorService.injector.get(MobileService);
	}
}
